import { IonApp, IonContent, IonSkeletonText, IonThumbnail } from "@ionic/react";
import React, { Component } from "react";
import Footer from "../../components/Footer";
import Toolbar from "../../components/Toolbar";
import Firebase from "../../firebase";
import "./style.css";
import createPlotlyComponent from "react-plotly.js/factory";
declare const window: any;
const Plotly = window.Plotly;
const Plot = createPlotlyComponent(Plotly);

class Player extends Component {
  state = {
    fb: Firebase.getInstance(),
    player: [] as any,
    data: {} as any,
    imgLoaded: false,
    x: [] as any,
    y: [] as any,
    text: [] as any,
  };

  async componentDidMount() {
    document.dispatchEvent(new Event("pageMount"));
    var data = await this.state.fb.readData("data");
    const playerID: any = window.location.pathname.split("/")[2];

    const y = [];
    const text = [];
    for (let gameID in data.Results) {
      if (data.Results[gameID] && data.Games[gameID] && data.Results[gameID][playerID]) {
        y.push(data.Results[gameID][playerID].score);
        let game = data.Games[gameID];
        text.push(
          game.description +
            "   " +
            new Date(game.firstTimeToBet).toLocaleDateString("HE") +
            " - " +
            new Date(game.lastTimeToBet).toLocaleDateString("HE")
        );
      }
    }
    const x = Array.from({ length: y.length }, (v, k) => k);
    this.setState({ data, player: data.Players[playerID], x, y, text });
  }

  render() {
    return (
      <IonApp>
        <Toolbar />
        <IonContent style={{ textAlign: "center" }}>
          <br />
          <IonThumbnail
            style={{
              width: "240px",
              height: "240px",
              marginRight: "auto",
              marginLeft: "auto",
              display: this.state.imgLoaded ? "none" : "block",
            }}
          >
            <IonSkeletonText animated />
          </IonThumbnail>
          <img
            src={this.state.player.picture}
            onLoad={() => {
              this.setState({ imgLoaded: true });
            }}
            style={{
              maxHeight: "240px",
              marginRight: "auto",
              marginLeft: "auto",
              display: !this.state.imgLoaded ? "none" : "block",
            }}
            alt="player"
          />
          <h1>
            <a href={this.state.player.ibbaUrl} target="_blank" rel="noopener noreferrer">
              {this.state.player.playerName}{" "}
            </a>
          </h1>

          <h2>
            {this.state.data.Positions ? this.state.data.Positions[this.state.player.positionID]?.description : ""}
          </h2>
          <h1>{this.state.data.Teams ? this.state.data.Teams[this.state.player.teamNumber].teamName : ""}</h1>
          <h2>מחיר: {this.state.player.cost}</h2>
          <br />
          <Plot
            data={[
              {
                x: this.state.x,
                y: this.state.y,
                text: this.state.text,
                type: "scatter",
              },
            ]}
            layout={{
              width: window.innerWidth * 0.9,
              height: window.innerHeight * 0.9,
              plot_bgcolor: "black",
              paper_bgcolor: "black",
              font: { color: "white" },
              title: {
                text: "ביצועים",
                font: {
                  size: 30,
                },
              },
              xaxis: {
                title: {
                  text: "שם המחזור",
                  font: {
                    size: 20,
                  },
                },
                tickmode: "array",
                tickvals: this.state.x,
                ticktext: this.state.text,
                showgrid: true,
                zeroline: true,
                showline: true,
                mirror: "ticks",
                gridcolor: "#bdbdbd",
                gridwidth: 1,
                zerolinecolor: "#bdbdbd",
                zerolinewidth: 1,
              },
              yaxis: {
                title: {
                  text: "מדד",
                  font: {
                    size: 20,
                  },
                },
                showgrid: true,
                zeroline: true,
                showline: true,
                mirror: "ticks",
                gridcolor: "#bdbdbd",
                gridwidth: 1,
                zerolinecolor: "#bdbdbd",
                zerolinewidth: 1,
              },
              shapes: [
                {
                  type: "line",
                  text: "מחיר",
                  xref: "paper",
                  x0: 0,
                  y0: this.state.player.cost,
                  x1: 1,
                  y1: this.state.player.cost,
                  line: {
                    color: "rgb(255, 0, 0)",
                    width: 4,
                    dash: "dot",
                  },
                },
              ],
              annotations: [
                {
                  x: 0,
                  y: this.state.player.cost,
                  xref: "x",
                  yref: "y",
                  text: "מחיר",
                  showarrow: true,
                  arrowhead: 3,
                },
              ],
            }}
          />
          <Footer />
        </IonContent>
      </IonApp>
    );
  }
}

export default Player;
